// extracted by mini-css-extract-plugin
module.exports = {"textAreaCell":"TextAreaCell_textAreaCell__2Qewt"};